import * as React from 'react';
import * as PropTypes from 'prop-types';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/settings.css';

import { Field, reduxForm, FormProps, InjectedFormProps } from 'redux-form';

interface ForgotPasswordCodeFormProps extends FormProps<InjectedFormProps, {}> {
  headerActions?: any;
  forgotPasswordCodeForm: any;
  request_param: any;
  passwordActions: any;
  dialogActions?: any;
}

class ForgotPasswordCodeForm extends React.Component <ForgotPasswordCodeFormProps, {}> {
  static propTypes = {
    passwordActions: PropTypes.any.isRequired,
  };

  handleChangeUsername(event: any) {
    // do nothing
  }

  handleChangeNewPassword(event: any) {
    // do nothing
  }

  handleChangeNewPasswordCheck(event: any) {
    // do nothing
  }

  handleChangeConfirmationCode(event: any) {
    // do nothing
  }

  handleSubmit(event: React.FormEvent<HTMLInputElement|HTMLFormElement>) {
    event.preventDefault();
    if (typeof(this.props.forgotPasswordCodeForm) === 'undefined') {
      return;
    }

    // undefinedになってた時に最低から文字にしてcognite側で判断させる
    const username = this.props.forgotPasswordCodeForm.username || '';
    const confirmationCode = this.props.forgotPasswordCodeForm.confirmationCode || '';
    const newPassword = this.props.forgotPasswordCodeForm.newPassword || '';
    const newPasswordCheck = this.props.forgotPasswordCodeForm.newPasswordCheck || '';

    this.props.passwordActions.confirmPasswordCode(
      username,
      confirmationCode,
      newPassword,
      newPasswordCheck,
      (res: any, message: string) => {
        if (res === false) {
          alert(message);
        }
      }
    );
  }

  render() {
    return (
      <div>
        <div id="procedure2" className="forgotPassword">
          <h2>メールに記載の認証コードと新しく設定するパスワードなどを入力してください</h2>
          <form>
            <table className="changePasswordForm">
              <tbody>
                <tr>
                  <th>認証コード</th>
                  <td>
                    <Field
                      id="inputConfirmationCode"
                      name="confirmationCode"
                      type="text"
                      placeholder="認証コード"
                      component="input"
                      required={true}
                      autoFocus={this.props.request_param.search.code ? false : true}
                      onChange={(e) => this.handleChangeConfirmationCode(e)}
                    />
                  </td>
                </tr>
                <tr>
                  <th>新しいパスワード</th>
                  <td>
                    <Field
                      id="inputNewPassword"
                      name="newPassword"
                      type="password"
                      placeholder="新しいパスワード"
                      component="input"
                      required={true}
                      autoFocus={this.props.request_param.search.code ? true : false}
                      onChange={(event) => this.handleChangeNewPassword(event)}
                    />
                  </td>
                </tr>
                <tr>
                  <th>(確認用)新しいパスワード</th>
                  <td>
                    <Field
                      id="inputNewPasswordConfirm"
                      name="newPasswordCheck"
                      type="password"
                      component="input"
                      placeholder="(確認用)新しいパスワード"
                      required={true}
                      onChange={(event) => this.handleChangeNewPasswordCheck(event)}
                    />
                  </td>
                </tr>
                <tr>
                  <th>事業所ID</th>
                  <td>
                    <Field
                      id="inputUsername"
                      name="username"
                      type="text"
                      component="input"
                      placeholder="事業所ID"
                      required={true}
                      onChange={(event) => this.handleChangeUsername(event)}
                    />
                  </td>
                </tr>
                <tr>
                  <th>&nbsp;</th>
                  <td>
                    <input
                      id="updatePasswordButton"
                      type="button"
                      className="btnStyle01"
                      value="パスワード更新"
                      onClick={(event) => this.handleSubmit(event)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div id="procedureDescription">
          <p>パスワード再発行手続きについて</p>
          <p>&nbsp;</p>
          <ul>
            <li>1. ご契約時のメールアドレス宛てにメールが届いている事を確認してください。*1 *2</li>
            <li>2. メールに「認証コード」が記載されているのを確認します。</li>
            <li>3. 認証コードを入力します。</li>
            <li>4. 新しいパスワードを入力します。</li>
            <li>5. (確認用)再度、新しいパスワードを入力します。</li>
            <li>6. 事業所IDを入力します。</li>
            <li>以上の手続きで、新しいパスワードの再発行手続きが完了です。</li>
            <li>(*1)1時間以内に届いているものだけ有効です。もし期限が過ぎていたら、パスワード再発行手続きを最初からやり直して下さい。</li>
            <li>(※2)メールは、ご契約情報として登録がされているメールアドレスに送信されます。もしお届けのメールアドレスに届いていない場合は、担当営業にお問い合わせください。</li>
          </ul>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'forgotPasswordCodeForm'
})(ForgotPasswordCodeForm as any);



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordCodeForm.tsx